export default __webpack_public_path__ + "static/media/login.33527658.wav";